import { render, staticRenderFns } from "./HealthQuestionEdit.vue?vue&type=template&id=569057b0&scoped=true"
import script from "./HealthQuestionEdit.vue?vue&type=script&lang=js"
export * from "./HealthQuestionEdit.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/review_edit.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569057b0",
  null
  
)

export default component.exports